import './profile.scss';
/* eslint import/first: 0 */
import feedbackPages from 'Feedback';
import profilePages from 'Profile';
import site from 'Site/site';

site();

const currentPage = document.querySelector('body').getAttribute('id');
const allPages = Object.assign({}, feedbackPages, profilePages);

if (typeof allPages[currentPage] !== 'undefined') {
    allPages[currentPage]();
}
